var arraySetOrder = ['pos0','pos4','pos8','pos1','pos5','pos9','pos2','pos3','pos6','pos7','pos10','pos11'];
var arrayOrder = [];
var urlLocation = location.href;
$(document).ready(function(){
  
  setTimeout(function(){ 
    $(".mobile-nav-wrapper > .gm-menu  > li:nth-child(2) > .gm-submenu > .gm-grid > .gm-item").each(function(index, value){
      // console.log(value);
      $(value).addClass(arraySetOrder[index]);
    });

    $(".mobile-nav-wrapper > .gm-menu  > li:nth-child(2) > .gm-submenu > .gm-grid > .gm-item").each(function(index, value){
      arrayOrder[index] = $(".mobile-nav-wrapper > .gm-menu  > li:nth-child(2) > .gm-submenu > .gm-grid > .gm-item.pos"+index)[0];
    });

    $(".mobile-nav-wrapper > .gm-menu  > li:nth-child(2) > .gm-submenu > .gm-grid > .gm-item").remove();
    $(arrayOrder).each(function(index, value){
      $(".mobile-nav-wrapper > .gm-menu  > li:nth-child(2) > .gm-submenu > .gm-grid").append(value); 
    });

    
    $(".mobile-nav-wrapper > .gm-menu  > li:nth-child(3) > .gm-submenu > .gm-grid > .gm-item").each(function(index, value){
      // console.log(value);
      $(value).addClass(arraySetOrder[index]);
    });

    $(".mobile-nav-wrapper > .gm-menu  > li:nth-child(3) > .gm-submenu > .gm-grid > .gm-item").each(function(index, value){
      arrayOrder[index] = $(".mobile-nav-wrapper > .gm-menu  > li:nth-child(3) > .gm-submenu > .gm-grid > .gm-item.pos"+index)[0];
    });

    $(".mobile-nav-wrapper > .gm-menu  > li:nth-child(3) > .gm-submenu > .gm-grid > .gm-item").remove();
    $(arrayOrder).each(function(index, value){
      $(".mobile-nav-wrapper > .gm-menu  > li:nth-child(3) > .gm-submenu > .gm-grid").append(value); 
    });

  }, 1000);

});


/* Connected Landing Page */
if(urlLocation.indexOf("products") !== -1){
	$(window).on('load',function(){
  // console.log("Connected Landing Page");
  
  var video_2 = $("#htcw");
  var video_3 = $("#dhwri");
  
  var videoTop_2 = video_2?.offset()?.top;
  var videoTop_3 = video_3?.offset()?.top;
 
  
  var autoplayVideo = function(){
  	var scrollTop = $(window).scrollTop();
    if(scrollTop >= (videoTop_2 - 300)){      
      
      video_2.get(0).play();
    }
    
    if(scrollTop >= (videoTop_3 - 300)){ 
      video_3.get(0).play();        
       
    }
  } 
  
  $(window).on("scroll",autoplayVideo);
  
});
}

if($(window).width() > 749){

$('.container-images-product-2').slick({
    vertical: true,
    verticalSwiping: true,
    autoplay: false,
    arrows: true,
    dots: false,
    slidesToShow: 5,
    adaptiveHeight: true,
    draggable: true,
    infinite: true,
    pauseOnHover: true,
    speed: 1000,
    autoplaySpeed: 2000,
    lazyLoad: 'ondemand',
    cssEase: 'linear',
    prevArrow: "<button type='button' class='slick-next-arrow'><img src='https://cdn.shopify.com/s/files/1/0550/3293/8662/files/expand_less_black_24dp.svg?v=1628208119' alt='Slider Siguiente'/></button>",
    nextArrow: "<button type='button' class='slick-prev-arrow'><img src='https://cdn.shopify.com/s/files/1/0550/3293/8662/files/expand_more_black_24dp.svg?v=1628208119' alt='Slider Anterior'/></button>",
    responsive: [
      {
        breakpoint: 1030,
        settings: {
          vertical: true,
          verticalSwiping: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: true,
          autoplay: true
        }
      },
      {
        breakpoint: 749,
        settings: {
          vertical: true,
    	  verticalSwiping: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          autoplay: true,
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

}else{
  $("#slider-imagenes-mobile .product-single__media-wrapper").removeClass("hide")

/*slider mobile*/

  $('#slider-imagenes-mobile').slick({
  infinite: true,
    arrows: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    autoplaySpeed: 3000,
    autoplay: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: true,
          autoplay: false
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          autoplay: true,
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
});
}

$(".desContenido p").addClass("description-product-festina");
$("#groupA").remove();
$(".section h2").addClass("header-especificaciones-product").append('<span class="close-icono-faq"></span></div>');




$(".description-info-festina").click(function(){
  if($(this).find('span').hasClass("close-icono-faq")){
  	$(this).find('span').removeClass("close-icono-faq").addClass("icon-acordeon-faq");
    $(".description-product-festina").css("display", "block");
    $(".title-metodo-envio").find('span').removeClass("icon-acordeon-faq").addClass("close-icono-faq");
    $(".description-product-festina").find('span').removeClass("icon-acordeon-faq").addClass("close-icono-faq");
    $(".tree .section .table").css("display", "none");
    $(".info-metodo-envio").css("display", "none");
  }else{
  	$(this).find('span').removeClass("icon-acordeon-faq").addClass("close-icono-faq");
    $(".description-product-festina").css("display", "none");
  }
})

$(".header-especificaciones-product").click(function(){
  if($(this).find('span').hasClass("close-icono-faq")){
  	$(this).find('span').removeClass("close-icono-faq").addClass("icon-acordeon-faq");
    $(".description-info-festina").find('span').removeClass("icon-acordeon-faq").addClass("close-icono-faq");
    $(".title-metodo-envio").find('span').removeClass("icon-acordeon-faq").addClass("close-icono-faq");
    $(".tree .section .table").css("display", "block");
    $(".info-metodo-envio").css("display", "none");
    $(".description-product-festina").css("display", "none");
  }else{
  	$(this).find('span').removeClass("icon-acordeon-faq").addClass("close-icono-faq");
    $(".tree .section .table").css("display", "none");
  }
})

$(".title-metodo-envio").click(function(){
  if($(this).find('span').hasClass("close-icono-faq")){
  	$(this).find('span').removeClass("close-icono-faq").addClass("icon-acordeon-faq");
    $(".header-especificaciones-product").find('span').removeClass("icon-acordeon-faq").addClass("close-icono-faq");
    $(".description-info-festina").find('span').removeClass("icon-acordeon-faq").addClass("close-icono-faq");
    $(".info-metodo-envio").css("display", "block");
    $(".description-product-festina").css("display", "none");
    $(".tree .section .table").css("display", "none");
  }else{
  	$(this).find('span').removeClass("icon-acordeon-faq").addClass("close-icono-faq");
    $(".info-metodo-envio").css("display", "none");
  }
})